import { PurchaseOrder } from "domain/entities/purchase-order";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface PurchaseOrderState {
  purchaseOrder: PurchaseOrder | null;
  setPurchaseOrder: (newPurchaseOrder: Partial<PurchaseOrder>) => void;
  resetPurchaseOrder: () => void;
}

const initialPurchaseOrderState: PurchaseOrder = {
  id: "",
  name: "",

  poNumber: "",
  type: "",
  status: "",
  plafound: 0,
  plafoundLeft: 0,
  fixedValue: 0,
  startAt: undefined,
  endAt: undefined,
  attachment: "",
  projectMembers: undefined,
  createdAt: undefined,
  modifiedAt: undefined,
};

export const usePurchaseOrderStore = create<PurchaseOrderState>()(
  devtools(
    (set) => ({
      purchaseOrder: initialPurchaseOrderState,
      setPurchaseOrder: (newPurchaseOrder) =>
        set((state) => ({
          purchaseOrder: {
            ...state.purchaseOrder,
            ...newPurchaseOrder,
          } as PurchaseOrder,
        })),
      resetPurchaseOrder: () =>
        set({ purchaseOrder: initialPurchaseOrderState }),
    }),
    { name: "PurchaseOrderSelected" }
  )
);
